// DS: C92
import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DaDreamupLogo from '@wix/da-ds/pkg/DaDreamupLogo';
import Flex from '@wix/da-ds/pkg/Flex';
import DeviationCoreBadgeList from '../coreBadge/CoreBadgeList/presets/DeviationCoreBadgeList';
import FaveStat from './FaveStat';
import CommentStat from './CommentStat';
import ViewStat from './ViewStat';
import SubscriberStat from './SubscriberStat';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import Stat from './Stat';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import { DeviationTypes } from '../types/deviation';
import { getDeviationType } from '../DeviationViews/_helpers';
import StampIcon from '../Das/StampIcon';
import { actions as modalActions } from '../Modals';
import { getCurrentUser, getCurrentUserHasCore } from '../publicSession/selectors';
import DAProtectIconWithTooltip from '../DAProtectIconWithTooltip';
import s from './Stats.scss';
const Stats = ({ deviation , onlyNumbers: showOnlyNumbers , withFavouriteControl =true , withCommentControl =true , withViewCount =true , withDas =true , withSubscriberCount =false , withBadges =true , withUserList =true , className , statClassName , badgelistClassName , onCommentClick  })=>{
    var _deviation_author, _deviation_digitalAsset, _deviation_digitalAsset1;
    const { t  } = useTranslation();
    const isMobile = useContext(MobileContext);
    const hasDas = useFlag('digital_assets');
    const deviationType = getDeviationType(deviation);
    const onlyNumbers = !!(showOnlyNumbers || isMobile);
    const dispatch = useDispatch();
    const { currentUser , hasCore  } = useSelector((state)=>({
            currentUser: getCurrentUser(state),
            hasCore: getCurrentUserHasCore(state)
        }));
    const isCurrentUserDeviationOwner = !!currentUser && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId) === ((_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.userId);
    const daProtectLevel = deviation.extended && deviation.extended.isDaProtected ? hasCore ? 'active' : 'temporary' : 'inactive';
    return /*#__PURE__*/ React.createElement(Flex, {
        className: className,
        justifyContent: "space-between"
    }, /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center"
    }, withFavouriteControl && /*#__PURE__*/ React.createElement(FaveStat, {
        className: statClassName,
        deviation: deviation,
        onlyNumbers: onlyNumbers,
        withUserList: !isMobile && withUserList
    }), withCommentControl && /*#__PURE__*/ React.createElement(CommentStat, {
        className: statClassName,
        deviation: deviation,
        onlyNumbers: onlyNumbers,
        withUserList: !isMobile && withUserList,
        onClick: onCommentClick
    }), withViewCount && /*#__PURE__*/ React.createElement(ViewStat, {
        className: statClassName,
        deviation: deviation,
        onlyNumbers: onlyNumbers
    }), withSubscriberCount && /*#__PURE__*/ React.createElement(SubscriberStat, {
        className: statClassName,
        deviation: deviation,
        onlyNumbers: onlyNumbers
    }), hasDas && withDas && ((_deviation_digitalAsset = deviation.digitalAsset) === null || _deviation_digitalAsset === void 0 ? void 0 : _deviation_digitalAsset.hasEditions) && /*#__PURE__*/ React.createElement(Stat, {
        deviation: deviation,
        icon: StampIcon,
        statNameLocaleKey: "deviation.stats.editions",
        statCount: (_deviation_digitalAsset1 = deviation.digitalAsset) === null || _deviation_digitalAsset1 === void 0 ? void 0 : _deviation_digitalAsset1.numEditions,
        onlyNumbers: onlyNumbers,
        biData: BiData({
            evid: 2,
            click_info: 'edition',
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue
        }),
        onClick: ()=>{
            dispatch(modalActions.pushDasModal('manage', deviation));
        }
    }), deviationType === DeviationTypes.IMAGE && isCurrentUserDeviationOwner && !deviation.isDreamsofart && /*#__PURE__*/ React.createElement(DAProtectIconWithTooltip, {
        withLabel: true,
        variant: daProtectLevel,
        className: s['da-protect']
    }), deviation.isDreamsofart && /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: s['dreamup-tag'],
        href: Url.dreamupLink()
    }, /*#__PURE__*/ React.createElement(DaDreamupLogo, {
        className: s['dreamup-icon']
    }), t('deviation.stats.dreamup'))), withBadges && /*#__PURE__*/ React.createElement(DeviationCoreBadgeList, {
        deviation: deviation,
        className: classnames(badgelistClassName, s['badges'])
    }));
};
export default Stats;
